export enum Result {
    Win = "win",
    Lose = "lose",
    None = "none"
}
  
export enum ModalTypes {
    Help = "help",
    AddClue = "addclue"
}

export enum GuessStatus {
    Correct = "correct",
    Incorrect = "incorrect",
    None = "none"
}